var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "percent_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#percent_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11a3.37 3.37 0 0 1-2.475-1.025A3.37 3.37 0 0 1 4 7.5q0-1.45 1.025-2.475A3.37 3.37 0 0 1 7.5 4q1.45 0 2.475 1.025A3.37 3.37 0 0 1 11 7.5q0 1.45-1.025 2.475A3.37 3.37 0 0 1 7.5 11m0-2q.624 0 1.063-.437Q9 8.124 9 7.5t-.437-1.062A1.45 1.45 0 0 0 7.5 6q-.625 0-1.062.438A1.45 1.45 0 0 0 6 7.5q0 .624.438 1.063Q6.874 9 7.5 9m9 11a3.37 3.37 0 0 1-2.475-1.025A3.37 3.37 0 0 1 13 16.5q0-1.45 1.025-2.475A3.37 3.37 0 0 1 16.5 13q1.45 0 2.475 1.025A3.37 3.37 0 0 1 20 16.5q0 1.45-1.025 2.475A3.37 3.37 0 0 1 16.5 20m0-2q.625 0 1.063-.437Q18 17.125 18 16.5t-.437-1.062A1.45 1.45 0 0 0 16.5 15q-.625 0-1.062.438A1.45 1.45 0 0 0 15 16.5q0 .625.438 1.063.437.437 1.062.437M4.7 19.3a.95.95 0 0 1-.275-.7q0-.425.275-.7L17.9 4.7a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L6.1 19.3a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275"
  }))));
};
export default SvgPercent;